import { Grid, Stack } from '@mui/material';
import { fetchLeadsetList } from '../../../actions/TeleAllocationAction';
import {
  defaultLeadsetState,
  getTeleAllocation,
  setCreateLeadsetState,
  setOpenCreateLeadsetDrawer,
} from '../../../features/teleAllocationSlice';
import { useSnackbar } from '../../../providers/SnackbarProvider';
import { useAppDispatch, useAppSelector } from '../../../store';
import { CreateLeadSet } from '../../../types/teleAllocation';
import { getErrorMessageFromErrorObj } from '../../../utils/api';
import LmTextField from '../../common/LmTextField';
import VegaButton from '../../common/VegaButton';
import VegaDrawerContent from '../../common/VegaDrawerContent';
import VegaFormInputField from '../../common/VegaFormInputField';
import ProcessSelector from '../components/ProcessSelector';
import VegaDrawer from '../../common/VegaDrawer';
import { TeleAllocationService } from '../../../Apis/TeleAllocationServices';
import { useState } from 'react';

const CreateLeadsetFormDrawer = () => {
  const { createLeadsetState, openCreateLeadsetDrawer } =
    useAppSelector(getTeleAllocation);
  const { setSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);

  const disabled =
    !createLeadsetState.name.length || !createLeadsetState.processId;

  const onClose = () => {
    dispatch(setOpenCreateLeadsetDrawer(false));
    dispatch(setCreateLeadsetState(defaultLeadsetState));
  };

  const handleChange = (key: keyof CreateLeadSet, value: string) => {
    const leadset = {
      ...createLeadsetState,
      [key]: value,
    };
    dispatch(setCreateLeadsetState(leadset));
  };

  function handleNameChange(value: string) {
    if (value.endsWith(' ')) {
      return;
    }

    handleChange('name', value);
  }

  const onCreateLeadset = async () => {
    setLoading(true);
    await TeleAllocationService.createLeadset(createLeadsetState)
      .then(() => {
        setSnackbar('Create Campaign Successfully !!!');
        dispatch(fetchLeadsetList({ page: 0, size: 10 }));
        onClose();
        setLoading(false);
      })
      .catch(error => {
        setSnackbar(getErrorMessageFromErrorObj(error), 'error');
        setLoading(false);
      });
  };

  return (
    <VegaDrawer
      title="Create Leadset"
      open={openCreateLeadsetDrawer}
      onClose={onClose}
    >
      <VegaDrawerContent
        renderBottomView={() => {
          return (
            <Stack direction={'row'} spacing="1rem">
              <VegaButton
                text="Create Leadset"
                disabled={disabled}
                onClick={onCreateLeadset}
                loading={loading}
              />
            </Stack>
          );
        }}
      >
        <Grid container spacing={'1.25rem'}>
          <Grid item xs={12}>
            <VegaFormInputField label={'leadset name'}>
              <LmTextField
                placeholder="Leadset Name"
                value={createLeadsetState.name}
                onChange={e => handleNameChange(e.target.value)}
              />
            </VegaFormInputField>
          </Grid>
          <Grid item xs={12}>
            <VegaFormInputField label={'Process id'}>
              <ProcessSelector
                selected={createLeadsetState.processId}
                handleChange={e => handleChange('processId', e)}
              />
            </VegaFormInputField>
          </Grid>
        </Grid>
      </VegaDrawerContent>
    </VegaDrawer>
  );
};

export default CreateLeadsetFormDrawer;
